var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulletListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.60723 0H1.2241C0.560967 0 0.015625 0.545237 0.015625 1.20847C0.0157278 1.87161 0.546257 2.43155 1.2241 2.43155H1.60723C2.27036 2.43155 2.8157 1.88632 2.8157 1.22308C2.8157 0.560053 2.27047 0 1.60723 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60723 5.7915H1.2241C0.560967 5.7915 0.015625 6.33674 0.015625 6.99998C0.015625 7.66311 0.560862 8.20845 1.2241 8.20845H1.60723C2.27036 8.20845 2.8157 7.66321 2.8157 6.99998C2.8157 6.33685 2.27047 5.7915 1.60723 5.7915Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60723 11.5684H1.2241C0.560967 11.5684 0.015625 12.1136 0.015625 12.7768C0.015625 13.44 0.560862 13.9853 1.2241 13.9853H1.60723C2.27036 13.9853 2.8157 13.4401 2.8157 12.7768C2.8157 12.1136 2.27047 11.5684 1.60723 11.5684Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.65989 2.4316H11.7757C12.4388 2.4316 12.9842 1.88636 12.9842 1.22312C12.9842 0.559991 12.4389 0.0146484 11.7757 0.0146484L5.65989 0.0147512C4.99676 0.0147512 4.45142 0.559988 4.45142 1.22322C4.45152 1.88636 4.99676 2.43159 5.65989 2.43159V2.4316Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7757 5.7915H5.65989C4.99676 5.7915 4.45142 6.33674 4.45142 6.99998C4.45142 7.66311 4.99665 8.20845 5.65989 8.20845H11.7757C12.4388 8.20845 12.9842 7.66321 12.9842 6.99998C12.9842 6.33685 12.4536 5.7915 11.7758 5.7915H11.7757Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7757 11.5684H5.65989C4.99676 11.5684 4.45142 12.1136 4.45142 12.7768C4.45142 13.44 4.99665 13.9853 5.65989 13.9853H11.7757C12.4388 13.9853 12.9842 13.4401 12.9842 12.7768C12.9842 12.1136 12.4536 11.5684 11.7758 11.5684H11.7757Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulletListIcon);
export default __webpack_public_path__ + "static/media/bulletListIcon.8a468b43.svg";
export { ForwardRef as ReactComponent };